import React, { useState } from "react";
import { Link } from "react-router-dom";

import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

import Logo from "../../assets/logo/come-to-be-coaching-logo.png";
import ICFlogo from "../../assets/logo/ICF-logo.png";

export const Footer = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <>
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <img
          style={{ height: "60px" }}
          src={ICFlogo}
          alt="ICF Logo"
        />
        <img style={{ height: "70px" }} src={Logo} alt="CTB Logo" />
      </div>
      <div
        style={{
          backgroundColor: "#340A3E",
          color: "white",
          padding: "50px 20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "50px",
            width: "100%",
            justifyContent: "space-evenly",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <p
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                lineHeight: "1.4",
              }}
            >
              Contact Info
            </p>
            <div>
              <p
                style={{ fontSize: "16px", lineHeight: "1.4" }}
              >
                1602 Tiara, Hiranandani Estate,
              </p>
              <p
                style={{ fontSize: "16px", lineHeight: "1.4" }}
              >
                Ghodbunder Road, Thane, Mumbai
              </p>
              <p
                style={{ fontSize: "16px", lineHeight: "1.4" }}
              >
                Area, MH 400607 IN
              </p>
            </div>
            <p
              style={{ fontSize: "16px", lineHeight: "1.4" }}

            >
              Phone : <a href="tel:+919819926379" style={{color: "#107988", textDecoration: "none"}}>+91 98199 26379</a>
            </p>
            <p
              style={{ fontSize: "16px", lineHeight: "1.4" }}
      
            >
              Email : <a href="mailto:crm@cometobecoaching.com" style={{color: "#107988", textDecoration: "none"}}>crm@cometobecoaching.com</a>
            </p>
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <p
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                lineHeight: "1.4",
              }}
            >
              Services
            </p>
            {[
              "Career Coaching",
              "Leadership Coaching",
              "Public Speaking Coaching",
              "ICF Coach Certification",
              "Life Coaching",
            ].map((item, index) => (
              <p
                key={index}
                style={{
                  fontSize: "16px",
                  lineHeight: "1.4",
                  color: hovered === item ? "#107988" : "white",
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHovered(item)}
                onMouseLeave={() => setHovered(null)}

              >
                <Link
                    to={`/services`}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "block",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    {item}
                  </Link>
              </p>
            ))}
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <p
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                lineHeight: "1.4",
              }}
            >
              Pages
            </p>
            {["Workshops", "Facts", "Quiz", "Policy", "FAQ"].map(
              (item, index) => (
                <p
                  key={index}
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.4",
                    color: hovered === item ? "#107988" : "white",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setHovered(item)}
                  onMouseLeave={() => setHovered(null)}

                >
                  <Link
                    to={`/${item.toLowerCase()}`}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "block",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    {item}
                  </Link>
                </p>
              )
            )}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '15px', fontSize: '24px' }}>
      <a href="https://www.facebook.com/people/CTB-Talent-Development-Services-LLP/61568182906410/" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}><FaFacebookF /></a>
      <a href="https://www.instagram.com/cometobecoaching" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}><FaInstagram /></a>
      <a href="https://www.linkedin.com/in/sunil-verma-mcc-5279582b/" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}><FaLinkedinIn /></a>
      <a href="https://www.youtube.com/@icfaccreditedcompetentcoac9154" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}><FaYoutube /></a>
    </div>

        <div
          style={{
            width: "80%",
            height: "1px",
            backgroundColor: "#d9d9d9",
          }}
        />
        <p
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            lineHeight: "1.4",
            textAlign: "center",
          }}
        >
          Copyright © 2024
          <span style={{ color: "#107988" }}> ComeToBeCoaching.com </span>- All
          Rights Reserved.
        </p>
      </div>
    </>
  );
};